<template>
  <div class="phone" v-if="$store.state.iframe.show">
    <div class="head">
      <h3>客服中心</h3>
      <i @click="guanbi" class="el-icon iconguanbi guanbi"></i>
    </div>
    <iframe
      class="iframe"
      :frameborder="0"
      :src="$store.state.iframe.src"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    guanbi() {
      this.$store.state.iframe.show = false;
    }
  }
};
</script>
<style scoped>
.head {
  width: 310px;
  height: 35px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.guanbi {
  position: absolute;
  right: 10px;
  top: 6px;
}
.phone {
  background-size: 100% 100%;
  z-index: 9999999;
  width: 310px;
  height: 500px;
  /* padding: 1px; */
  position: fixed;
  bottom: 30px;
  right: 60px;
  box-shadow: darkgrey 10px 10px 30px 5px;
}
.iframe {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/iframeKf.vue